import getEnvVar from '@/lib/getEnvVar'

export const CONSTANTS = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_GROUP_ADMIN: 'ROLE_GROUP_ADMIN',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_SOUND_ADMIN: 'ROLE_SOUND_ADMIN',
  ROLE_INSIGHT_ADMIN: 'ROLE_INSIGHT_ADMIN',
  ROLE_STORE_ADMIN: 'ROLE_STORE_ADMIN',
  ROLE_STORE_BAG_ADMIN: 'ROLE_STORE_BAG_ADMIN',
  ROLE_SCHOOL_ADMIN: 'ROLE_SCHOOL_ADMIN',
  ROLE_PHARMEDICALL_ADMIN: 'ROLE_PHARMEDICALL_ADMIN',
  ROLE_PHARMEDICALL_PROCEDURE_ADMIN: 'ROLE_PHARMEDICALL_PROCEDURE_ADMIN',
  ROLE_CARE_ADMIN_SUPPORT: 'ROLE_CARE_ADMIN_SUPPORT',
  ROLE_CARE_ADMIN_CONSULT: 'ROLE_CARE_ADMIN_CONSULT',
  ROLE_MCP_ACCESS: 'ROLE_MCP_ACCESS',
  // Serveur MCP en lecture sur l'Odoo de LAP : n'ouvre que ces outils, ni /mcp ni le back-office.
  ROLE_MCP_ODOO_LAP: 'ROLE_MCP_ODOO_LAP',
  ROLE_SIRET_CONTROL: 'ROLE_SIRET_CONTROL',
  ROLE_AI_DICTATION: 'ROLE_AI_DICTATION',
  ROLE_PHARMEDIGROUP_EXTENSION: 'ROLE_PHARMEDIGROUP_EXTENSION',
  // Profil « Saisie des declarations » : la page Declarations (EPS, <= 2 000 € TTC) et rien d'autre.
  ROLE_DECLARATION_ENTRY: 'ROLE_DECLARATION_ENTRY',
  // Profil « Logistique Store » (front#771) : l'écran Logistique Store du menu Ma centrale et rien d'autre.
  ROLE_STORE_LOGISTICS: 'ROLE_STORE_LOGISTICS',

  ROLE_PHARMACIEN: 'ROLE_PHARMACIEN',

  ROLE_COTITULAIRE_PHARMACIEN: 'ROLE_COTITULAIRE_PHARMACIEN',
  ROLE_ADJOINT_PHARMACIEN: 'ROLE_ADJOINT_PHARMACIEN',
  ROLE_PREPARATEUR: 'ROLE_PREPARATEUR',
  ROLE_AIDE_PREPARATEUR: 'ROLE_AIDE_PREPARATEUR',
  ROLE_CONSEILLER_BEAUTE: 'ROLE_CONSEILLER_BEAUTE',
  ROLE_RAYONNISTE: 'ROLE_RAYONNISTE',
  ROLE_CONSEILLER_PARAPHARMACIE: 'ROLE_CONSEILLER_PARAPHARMACIE',
  ROLE_TEAM_OTHER: 'ROLE_TEAM_OTHER',

  ROLE_EQUIPE_USER: 'ROLE_EQUIPE_USER',
  ROLE_STUDENT_USER: 'ROLE_STUDENT_USER',

  ROLE_PARAPHARMACY_USER_MANAGER: 'ROLE_PARAPHARMACY_USER_MANAGER',

  ROLE_HEALTH_PROFESSIONAL_MANAGER: 'ROLE_HEALTH_PROFESSIONAL_MANAGER',

  ROLE_CONSULT_CONTRACT_USER: 'ROLE_CONSULT_CONTRACT_USER',
  ROLE_CONSULT_USER_SFTP: 'ROLE_CONSULT_USER_SFTP',

  ROLE_GROUPEMENT_MANAGER: 'ROLE_GROUPEMENT_MANAGER',
  ROLE_URPS_MANAGER: 'ROLE_URPS_MANAGER',
  ROLE_CHAIN_MANAGER: 'ROLE_CHAIN_MANAGER',

  ROLE_CHAIN_ZONE_MANAGER: 'ROLE_CHAIN_ZONE_MANAGER',
  ROLE_ZONE_CONSULTANT: 'ROLE_ZONE_CONSULTANT',

  ROLE_INDUSTRY_USER_PMI_DIY: 'ROLE_INDUSTRY_USER_PMI_DIY',
  ROLE_INDUSTRY_USER_SCHOOL: 'ROLE_INDUSTRY_USER_SCHOOL',
  ROLE_INDUSTRY_USER_SCHOOL_DELEGUE: 'ROLE_INDUSTRY_USER_SCHOOL_DELEGUE',
  ROLES_USER_SCHOOL_APPRENANT: 'ROLES_USER_SCHOOL_APPRENANT',
  ROLE_INDUSTRY_USER_STORE_VENDOR: 'ROLE_INDUSTRY_USER_STORE_VENDOR',
  ROLE_INDUSTRY_USER_SOUND_DIY: 'ROLE_INDUSTRY_USER_SOUND_DIY',

  // Espace Industry (hierarchie : ADMINISTRATOR (ex-SIEGE) >= DR >= DP, cote @group-api security.yaml)
  ROLE_INDUSTRY_USER_ADMINISTRATOR: 'ROLE_INDUSTRY_USER_ADMINISTRATOR',
  // Fonction « Siège » (22/10/2026) : droits de l'administrateur sans les utilisateurs, les
  // zones, la mise à jour en masse ni l'administration des modules.
  ROLE_INDUSTRY_HEAD_OFFICE: 'ROLE_INDUSTRY_HEAD_OFFICE',
  ROLE_INDUSTRY_DR: 'ROLE_INDUSTRY_DR',
  ROLE_INDUSTRY_DP: 'ROLE_INDUSTRY_DP',
  // Delegation du pouvoir d'owner de la fiche (labo/groupement) — equivalent industry du
  // ROLE_DELEGATE_PHARMACIEN_CO_TITU pharmacie. Donne ROLE_DYNAMIC_INDUSTRY_OFFICE_OWNER.
  ROLE_INDUSTRY_USER_SHARE_OWNER: 'ROLE_INDUSTRY_USER_SHARE_OWNER',
  // Administration des modules du labo (activation self-service + attribution des acces
  // aux users). Herite par ROLE_INDUSTRY_USER_ADMINISTRATOR cote @group-api security.yaml.
  ROLE_INDUSTRY_MODULE_ADMIN: 'ROLE_INDUSTRY_MODULE_ADMIN',

  ROLE_USER_DELEGATE_MANAGER_STORE: 'ROLE_USER_DELEGATE_MANAGER_STORE',
  ROLE_USER_DELEGATE_MANAGER_CARE: 'ROLE_USER_DELEGATE_MANAGER_CARE',
  ROLE_DELEGATE_PHARMACIEN_CO_TITU: 'ROLE_DELEGATE_PHARMACIEN_CO_TITU',
  ROLE_COMPTOIR: 'ROLE_COMPTOIR',

  //ROLES DYNAMIC

  ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN: 'ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN',
  ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN: 'ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN',
  ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN: 'ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN',
  ROLE_DYNAMIC_ROUTE_SOUND_ADMIN: 'ROLE_DYNAMIC_ROUTE_SOUND_ADMIN',
  ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN: 'ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN',
  ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN: 'ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN',
  ROLE_DYNAMIC_ROUTE_SCHOOL_INTERNE_ADMIN_CONSULT:
    'ROLE_DYNAMIC_ROUTE_SCHOOL_INTERNE_ADMIN_CONSULT',
  ROLE_DYNAMIC_ROUTE_STORE_ADMIN: 'ROLE_DYNAMIC_ROUTE_STORE_ADMIN',
  ROLE_DYNAMIC_ROUTE_PLV_ADMIN: 'ROLE_DYNAMIC_ROUTE_PLV_ADMIN',
  ROLE_DYNAMIC_ROUTE_GROUP_ADMIN: 'ROLE_DYNAMIC_ROUTE_GROUP_ADMIN',

  ROLE_DYNAMIC_ROUTE_GROUP_PHARMACIEN: 'ROLE_DYNAMIC_ROUTE_GROUP_PHARMACIEN',
  ROLE_DYNAMIC_ROUTE_INSIGHT_PHARMACIEN: 'ROLE_DYNAMIC_ROUTE_INSIGHT_PHARMACIEN',
  ROLE_DYNAMIC_ROUTE_SCHOOL_MANAGER_LEARNER: 'ROLE_DYNAMIC_ROUTE_SCHOOL_MANAGER_LEARNER',
  ROLE_DYNAMIC_ROUTE_SCHOOL_INDUSTRY_MANAGER: 'ROLE_DYNAMIC_ROUTE_SCHOOL_INDUSTRY_MANAGER',

  ROLE_DYNAMIC_ROUTE_SOUND_ONBOARDING_PHARMACIEN_IT:
    'ROLE_DYNAMIC_ROUTE_SOUND_ONBOARDING_PHARMACIEN_IT',
  ROLE_DYNAMIC_ROUTE_SOUND_ONBOARDING_PHARMACIEN_FR:
    'ROLE_DYNAMIC_ROUTE_SOUND_ONBOARDING_PHARMACIEN_FR',
  ROLE_DYNAMIC_ROUTE_SOUND_PHARMACIEN_ACTIVE: 'ROLE_DYNAMIC_ROUTE_SOUND_PHARMACIEN_ACTIVE',
  ROLE_DYNAMIC_ROUTE_SOUND_PHARMACIEN_IT: 'ROLE_DYNAMIC_ROUTE_SOUND_PHARMACIEN_IT',
  ROLE_DYNAMIC_ROUTE_SOUND_MANAGER_RADIO: 'ROLE_DYNAMIC_ROUTE_SOUND_MANAGER_RADIO',

  ROLE_DYNAMIC_ROUTE_STORE_MANAGE: 'ROLE_DYNAMIC_ROUTE_STORE_MANAGE',
  ROLE_DYNAMIC_ROUTE_PLV_PHARMACIEN: 'ROLE_DYNAMIC_ROUTE_PLV_PHARMACIEN',

  ROLE_DYNAMIC_ROUTE_GROUP_USER_TEAM: 'ROLE_DYNAMIC_ROUTE_GROUP_USER_TEAM',
  ROLE_DYNAMIC_ROUTE_INSIGHT_USER_TEAM: 'ROLE_DYNAMIC_ROUTE_INSIGHT_USER_TEAM',
  ROLE_DYNAMIC_ROUTE_SCHOOL_USER_TEAM: 'ROLE_DYNAMIC_ROUTE_SCHOOL_USER_TEAM',

  ROLE_DYNAMIC_OWNER_USER_COMPANY: 'ROLE_DYNAMIC_OWNER_USER_COMPANY',
  ROLE_DYNAMIC_OWNER_PHARMACY: 'ROLE_DYNAMIC_OWNER_PHARMACY',
  // Professionnel de sante hors officine (kine) proprietaire de sa structure Care-eligible
  // (cf. CompanyType::careMissionThemes cote API). Existe AVANT l'activation de Care : c'est
  // lui qui autorise le kine a activer Care sur sa propre structure.
  ROLE_DYNAMIC_OWNER_CARE_HEALTH_PROFESSIONAL: 'ROLE_DYNAMIC_OWNER_CARE_HEALTH_PROFESSIONAL',
  ROLE_DYNAMIC_INDUSTRY_OFFICE_OWNER: 'ROLE_DYNAMIC_INDUSTRY_OFFICE_OWNER',
  ROLE_DYNAMIC_HOLD_OWNER_PHARMACY: 'ROLE_DYNAMIC_HOLD_OWNER_PHARMACY',
  ROLE_DYNAMIC_ROUTE_HOLD_OWNER_INSIGHT: 'ROLE_DYNAMIC_ROUTE_HOLD_OWNER_INSIGHT',
  ROLE_DYNAMIC_ROUTE_HOLD_OWNER_SOUND: 'ROLE_DYNAMIC_ROUTE_HOLD_OWNER_SOUND',
  ROLE_DYNAMIC_ROUTE_HOLD_OWNER_PLV: 'ROLE_DYNAMIC_ROUTE_HOLD_OWNER_PLV',
  ROLE_DYNAMIC_ROUTE_USER_SCHOOL: 'ROLE_DYNAMIC_ROUTE_USER_SCHOOL',

  //User groupement consult pharmacie into groupement for display campaign sound
  ROLE_DYNAMIC_ROUTE_SOUND_GROUPEMENT_CHAIN_USER: 'ROLE_DYNAMIC_ROUTE_SOUND_GROUPEMENT_CHAIN_USER',
  //User groupement consult pharmacie into groupement for display training school
  ROLE_DYNAMIC_ROUTE_SCHOOL_GROUPEMENT_CHAIN_USER:
    'ROLE_DYNAMIC_ROUTE_SCHOOL_GROUPEMENT_CHAIN_USER',
  ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_MANAGER:
    'ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_MANAGER',
  // Tout membre de l'espace groupement / chaine (managers compris) : pages communes.
  ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_USER: 'ROLE_DYNAMIC_ROUTE_GROUP_GROUPEMENT_CHAIN_USER',
  ROLE_DYNAMIC_ROUTE_GROUP_URPS_USER: 'ROLE_DYNAMIC_ROUTE_GROUP_URPS_USER',
  //User groupement whose « Ma centrale » (Store) customer account is linked AND active
  ROLE_DYNAMIC_ROUTE_STORE_GROUPEMENT_CHAIN_USER:
    'ROLE_DYNAMIC_ROUTE_STORE_GROUPEMENT_CHAIN_USER',

  ROLE_DYNAMIC_ROUTE_SCHOOL_GROUPEMENT_CHAIN_MANAGER:
    'ROLE_DYNAMIC_ROUTE_SCHOOL_GROUPEMENT_CHAIN_MANAGER',

  ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_STORE_VENDOR: 'ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_STORE_VENDOR',
  ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_ENTITY_GROUP: 'ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_ENTITY_GROUP',

  ROLE_DYNAMIC_ROUTE_CONSULT_USER_SFTP: 'ROLE_DYNAMIC_ROUTE_CONSULT_USER_SFTP',
  ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_PMI_DIY: 'ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_PMI_DIY',
  ROLE_DYNAMIC_ROUTE_CONSULT_CONTRACT_USER: 'ROLE_DYNAMIC_ROUTE_CONSULT_CONTRACT_USER',
  ROLE_DYNAMIC_ROUTE_STUDENT_USER: 'ROLE_DYNAMIC_ROUTE_STUDENT_USER',

  ROLE_DYNAMIC_ROUTE_CARE_MANAGE: 'ROLE_DYNAMIC_ROUTE_CARE_MANAGE',
  ROLE_DYNAMIC_ROUTE_CARE_ADMIN_CONSULT: 'ROLE_DYNAMIC_ROUTE_CARE_ADMIN_CONSULT',
  // Perimetre Care complet (officine) : accorde en plus de CARE_MANAGE uniquement aux
  // pharmacies. Absent pour un professionnel de sante hors officine (kine) — le front s'en
  // sert pour masquer les ecrans propres a l'officine (LGO, comptoir, equipe, base produit).
  ROLE_DYNAMIC_ROUTE_CARE_FULL_SCOPE: 'ROLE_DYNAMIC_ROUTE_CARE_FULL_SCOPE',
}

/**
 * Roles having access to Sound admin features (full France admin + Italy-restricted admin)
 */
export const ROLES_SOUND_ADMIN_ALL = [
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN,
]

/**
 * LIST roles authorize for user backoffice
 */

//replace by CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_ADMIN
export const LIST_ROLES_AUTHORIZE_BACK_OFFICE_ADMIN = [
  CONSTANTS.ROLE_DYNAMIC_ROUTE_PHARMEDICALL_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ITALY_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_INTERNE_ADMIN_CONSULT,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_ADMIN,
  CONSTANTS.ROLE_DYNAMIC_ROUTE_CARE_ADMIN_CONSULT,
  // Seul rôle d'un compte de saisie des déclarations : il doit ouvrir le back-office.
  CONSTANTS.ROLE_DECLARATION_ENTRY,
  // Seul rôle possible du compte de la logistique (écran Logistique Store).
  CONSTANTS.ROLE_STORE_LOGISTICS,
]

/**
 * Rôles qui accordent RÉELLEMENT `ROLE_ADMIN` côté API — copie fidèle du `role_hierarchy`
 * de `@group-api` (`config/packages/security.yaml`). À utiliser pour n'afficher un geste
 * qu'aux comptes que l'API laissera passer.
 *
 * Ce n'est PAS {@link LIST_ROLES_AUTHORIZE_BACK_OFFICE_ADMIN}, qui ouvre l'accès au
 * back-office et inclut les rôles de CONSULTATION (`*_ADMIN_CONSULT`, hérités de
 * `ROLE_USER`) : s'en servir pour un bouton d'écriture afficherait l'action à des comptes
 * qui reçoivent un 403 en cliquant.
 *
 * Les rôles sont les rôles BRUTS (`loggedUserRoles` porte ceux stockés sur le compte, plus
 * les `ROLE_DYNAMIC_ROUTE_*` dérivés) : l'héritage Symfony n'est résolu qu'à l'appel API,
 * un admin School n'a donc jamais `ROLE_ADMIN` dans la liste.
 */
export const LIST_ROLES_GRANTING_API_ROLE_ADMIN = [
  CONSTANTS.ROLE_SUPER_ADMIN,
  CONSTANTS.ROLE_GROUP_ADMIN,
  CONSTANTS.ROLE_INSIGHT_ADMIN,
  CONSTANTS.ROLE_SOUND_ADMIN,
  CONSTANTS.ROLE_STORE_ADMIN,
  CONSTANTS.ROLE_STORE_BAG_ADMIN,
  CONSTANTS.ROLE_SCHOOL_ADMIN,
  CONSTANTS.ROLE_PHARMEDICALL_ADMIN,
  CONSTANTS.ROLE_PHARMEDICALL_PROCEDURE_ADMIN,
]

/**
 * LIST roles authorize for user front
 */

export const ROLES_USER_TEAM = [
  CONSTANTS.ROLE_COTITULAIRE_PHARMACIEN,
  CONSTANTS.ROLE_ADJOINT_PHARMACIEN,
  CONSTANTS.ROLE_PREPARATEUR,
  CONSTANTS.ROLE_AIDE_PREPARATEUR,
  CONSTANTS.ROLE_CONSEILLER_BEAUTE,
  CONSTANTS.ROLE_RAYONNISTE,
  CONSTANTS.ROLE_CONSEILLER_PARAPHARMACIE,
  CONSTANTS.ROLE_TEAM_OTHER,
]

export const PATIENT_DOMAINS = [
  'monsuivipharma.com',
  'staging.monsuivipharma.com',
  'www.monsuivipharma.com',
]

export const PHARMEDICARE_URL =
  getEnvVar('APP_ENV') === 'production'
    ? PATIENT_DOMAINS.find(d => !d.includes('staging'))
    : PATIENT_DOMAINS.find(d => d.includes('staging'))

export const PHARMACIES = 'Pharmacies'
export const FACTURES = 'Factures'
export const USER = 'USER'
export const FACTURE = 'Facture'

/**
 * « Type de demande » d'un pavé CRM saisi à la main (chantier « Qualité des fiches », lot 6).
 * Même liste que `CrmTaskTypeCode::manualChoices()` (@group-api) : les changer ensemble.
 *
 * Défini ICI et non dans `lib/crm/crmTaskTypeChoices.ts` (qui le réexporte) : le schéma Zod de
 * `src/ApiMutationEndpoint.ts` le lit, et ce fichier est déjà chargé par le shell — un module de
 * plus dans l'arbre synchrone ferait dépasser `scripts/check-shell-budget.cjs`.
 */
export const CRM_TASK_TYPE_CHOICES = [
  'crm_manual',
  'pharmacy_cession',
  'pharmacy_relocation',
  'pharmacy_update',
] as const

/**
 * Ce qui change sur la fiche, coché sur une demande de mise à jour (23/10/2026). Même liste que
 * `PharmacyUpdateReason` (@group-api) : les changer ensemble. Ici pour la même raison que la
 * liste ci-dessus (schéma Zod de `src/ApiMutationEndpoint.ts`, budget du shell).
 */
export const PHARMACY_UPDATE_REASONS = [
  'holder',
  'email',
  'phone',
  'hours',
  'groupement',
  'address',
  'name',
  'cip',
  'bank',
  'other',
] as const

export type PharmacyUpdateReason = (typeof PHARMACY_UPDATE_REASONS)[number]

export type CrmTaskTypeChoice = (typeof CRM_TASK_TYPE_CHOICES)[number]

export const CRM_TASK_TYPE_DEFAULT: CrmTaskTypeChoice = 'crm_manual'
